// 测试环境
// const httpUrl = 'http://localhost:55000'
 const httpUrl = 'https://apitest.freepos.es'

// 商品<租户SellerID>
 const goods = httpUrl + '/ibProduct/GetProducts'

// 全部订单<租户SellerID>
 const getOrderAll = httpUrl + '/ibOrder/GetOrderAll'

// 提交订单POST<租户SellerID>
 const createOrder = httpUrl + '/ibOrder/CreateOrder'

// 餐馆商家信息?ID=1&<租户SellerID>
 const getSeller = httpUrl + '/ibSellers/GetSeller'

// 客户信息?ID=1& 租户 SellerID=1
 const getUser = httpUrl + '/ibUsers/GetUser'

// 提交用户信息POST
 const createUser = httpUrl + '/ibUsers/CreateMiniUser'

 // 修改用户信息
 const modifyUserInfo = httpUrl + '/ibUsers/ModifyUserInfo'

 // 新用户检查是否重名
 const checkUserExist = httpUrl + '/ibUsers/CheckUserExist?username='

 export default {
   httpUrl,
   goods,
   getOrderAll,
   createOrder,
   getSeller,
   getUser,
   createUser,
   modifyUserInfo,
   checkUserExist
 }



// WEBPACK FOOTER //
// ./src/common/js/api.js